<template>
  <div class="FormSite">
    <Row>
      <Column :md="6">
        <Field
          data-cy="name"
          :label="$t('name')"
          required
          :value.sync="site.name" />
      </Column>
      <Column :md="6">
        <Field
          data-cy="siteUrl"
          :label="$t('siteUrl')"
          required
          :value.sync="site.url" />
      </Column>
    </Row>
    <Row>
      <Column :md="4">
        <Field
          :label="$t('tag')"
          required
          :value.sync="site.tag" />
      </Column>
      <Column :md="4">
        <Field
          :label="$t('seoPlugin')"
          :options="seoPlugins"
          required
          type="select"
          :value.sync="site.seoPlugin" />
      </Column>
      <Column :md="4">
        <Field
          :label="$t('companyId')"
          required
          type="number"
          :value.sync="site.companyId" />
      </Column>
    </Row>
    <Field
      data-cy="jwt"
      :label="$t('jwt')"
      required
      :value.sync="site.jwt" />
    <MultiSelect
      :options="userOptions"
      :value="siteUserIds"
      @update:value="updateSiteUsers" />
    <SiteSettings
      :value="site.settings"
      @update:value="$up('site.settings', $event)" />
    <Row v-if="type !== 'new'">
      <Column :md="6">
        <Field
          data-cy="createdAt"
          disabled
          :label="$t('createdAt')"
          :value="site.createdAt" />
      </Column>
      <Column :md="6">
        <Field
          data-cy="updatedAt"
          disabled
          :label="$t('updatedAt')"
          :value="site.updatedAt" />
      </Column>
    </Row>
  </div>
</template>

<script>
import MultiSelect from '@components/fields/MultiSelect'
import SiteSettings from './SiteSettings'
import { getters } from '@utils'
import { pluck } from 'rambda'

export default {
  components: { MultiSelect, SiteSettings },
  props: {
    site: Object,
    type: String,
  },
  computed: {
    siteUserIds() {
      return pluck('userId', this.site.siteUsers)
    },
    ...getters('userOptions', 'seoPlugins'),
  },
  methods: {
    updateSiteUsers(userIds) {
      this.site.siteUsers = userIds.map((userId) => ({ userId }))
    },
  },
}
</script>

<style lang="scss">
.FormSite {
  padding-bottom: 1rem;
}
</style>

<i18n>
{
  "en": {
    "companyId": "Company ID",
    "createdAt": "Date created",
    "jwt": "JWT token",
    "name": "Site name",
    "seoPlugin": "SEO plugin",
    "siteUrl": "Site URL",
    "tag": "Affiliate tag",
    "updatedAt": "Date updated"
  }
}
</i18n>
